import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const PART_REQUEST_SUBJECT = encodeURIComponent("Special Order / Part Request");

/**
 * Catchy call-to-action that invites visitors to get in touch when they cannot
 * find the part they need. Shown on the home page and every category page so a
 * visitor always knows they can simply ask. The company name is pulled live
 * from Site Settings.
 */
export default function PartRequestNotice() {
  const { t } = useTranslation();
  const { site, contactDetails, contactDisplay } = useSiteSettings();
  const phone = contactDetails.find((c) => c.type === "phone");

  return (
    <section className="w-full bg-brand-gold py-14 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-dark px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-brand-gold">
          <i className="ri-search-eye-line"></i>
          {t("request.badge")}
        </span>
        <h2 className="mt-5 font-heading text-3xl font-semibold uppercase text-brand-dark md:text-4xl">
          {t("request.title")}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-brand-dark/80 md:text-base">
          {t("request.text", { siteName: site.site_name })}
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={`/contact-us?subject=${PART_REQUEST_SUBJECT}`}
            className="flex items-center gap-2 rounded-md bg-brand-dark px-7 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-black whitespace-nowrap"
          >
            <i className="ri-send-plane-line"></i>
            {t("request.cta")}
          </Link>
          {contactDisplay.phone_part_request && phone && (
            <a
              href={`tel:${phone.value.replace(/\s/g, "")}`}
              className="flex items-center gap-2 rounded-md border border-brand-dark px-7 py-3 text-sm font-semibold uppercase tracking-wide text-brand-dark transition hover:bg-brand-dark hover:text-white whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              {phone.value}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}